// extracted by mini-css-extract-plugin
export default {"block":"SummaryBlock_block__IB8M0","header":"SummaryBlock_header__YkT2V font-sm-medium","accordion__summary":"SummaryBlock_accordion__summary__9WFew"};